module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("September")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Robert Winter")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Pride and Joy: Book 1")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("David James is smart, successful, handsome… and alone. After the death of his lover, Kyle, from cancer, he buried himself in his law practice and the gym. At forty-eight, he is haunted by his memories and walled off from the world. When David injures himself working out, he’s assigned to Brandon Smith for physical therapy. The vibrant young therapist is attracted to David and realizes he needs a hand to get back into dating. What begins as a practice coffee date escalates to friendship, passion, and maybe something more, as they navigate a new relationship in Washington, DC, and the gay mecca of Provincetown.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But David remains trapped behind the barrier of fear and guilt. Will he remain loyal to Kyle’s memory if he moves on? Can he and Brandon manage a twenty-two-year age gap? Brandon thinks he understands David’s concerns, and for him, the answer to those questions is yes. He wants to be with David, and he believes he can overcome David’s barriers. But Brandon fails to account for the world’s reaction to a handsome young man attached to an older, wealthy lover. David’s memories, Brandon’s pride, and an unexpected tragedy might cost them something very special.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 57
// module chunks = 0